export default __webpack_public_path__ + "static/media/spin.d2c04dbd.webp";